var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-1"},[_c('app-input',{attrs:{"type":"single-checkbox","id":'checkbox-value-'+_vm.rowData.id,"disabled":_vm.checkboxValue,"list-value-field":_vm.$t(' ')},on:{"input":_vm.setActivityStatusDone},model:{value:(_vm.checkboxValue),callback:function ($$v) {_vm.checkboxValue=$$v},expression:"checkboxValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }